export default __webpack_public_path__ + "static/media/Farspire.8a44b1c3.jpg";